import React, { useEffect, useState } from "react";
import "./proMembershipInvoiceCN.scss";
import user from "../../../store/user";
import { getQueryParams, isTechDomain } from "../../../utils/utilFunctions";
import Button from "../../../components/Button";
import Loader from "../../../components/Loader";
import { Header, Modal, Table } from "semantic-ui-react";
import { ToastContainer, toast } from "react-toastify";
import Dropdown from "../../../components/Dropdown/Dropdown";
import FromToDatePicker from "../../../components/FromToDatepicker";
import ButtonContainer from "../../../components/ButtonContainer";
import InputBox from "../../../components/InputBox";
import moment from "moment";
import Document from "react-pdf/dist/esm/Document";
import Page from "react-pdf/dist/esm/Page";
import getProMemberShipInvoiceCreditNotesList from "../../../services/getProMemberShipInvoiceCreditNotesList";
import createCreditNote from "../../../services/createCreditNote";
import Heading from "../../../components/Heading";
import { adminFeatureMapping } from '../../../models/adminFeatureMapping';


const PAGE_CONTENT = 50;

const subscriptionTypeList = [
  { id: "", name: "Select" },
  { id: 1, name: "Pro Membership Plan" },
  { id: 2, name: "Early Applicant Plan" },
  { id: 3, name: "Resume Builder Plan" },
  { id: 4, name: "Early Applicant & Resume Builder Plan" },
];

const invoiceTypeList = [
  { id: "", name: "Select" },
  { id: 'invoice', name: "Invoice" },
  { id: 'credit note', name: "Credit Note" },
];

const paymentGatewayList = [
  { id: "", name: "Select" },
  { id: `${process.env.REACT_APP_PLATFORM}_apple`, name: `${process.env.REACT_APP_PLATFORM}_APPLE` },
  { id: `${process.env.REACT_APP_PLATFORM}_payu`, name: `${process.env.REACT_APP_PLATFORM}_PAYU` },
];

const ProMembershipInvoiceCN = (props) => {
  const [content, setContent] = useState({
    list: [],
    count: 0,
    offset: 0,
  });

  const [admin, setAdmin] = useState({
    adminId: null,
  });

  const [fetchApiCall, setFetchApiCall] = useState(true);

  const [pagination, setPagination] = useState({
    nextPage: null,
    prevPage: null,
    showPagination: true,
    showPrev: true,
    showNext: true,
  });

  const [inputData, setInputData] = useState({
    paymentGatewayId: "",
    documentNo: "",
  });

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    paymentGatewayId: null,
    subscriptionType: "",
    invoiceType: "",
    documentNo: "",
    paymentGateway: "",
  });

  const [modalItem, setModalItem] = useState(null);
  const [creditNoteModal, setCreditNoteModal] = useState(null);

  const [viewInvoiceModal, setViewInvoiceModal] = useState(false);

  const [invoiceNumPages, setInvoiceNumPages] = useState(1);

  const [downloadingExcel, setDownloadingExcel] = useState(false);
  
  const [genCreditNote, setGenCreditNote] = useState(false);

  const [paginationList, setPaginationList] = useState([{
    documentType: 'invoice',
    offset: 0
  }]);

  const [hasCNGenerationAccess, setHasCNGenerationAccess] = useState(false);
  
  useEffect(() => {
    const newPagination = {...pagination};
    if(paginationList.length < 3) {
      newPagination['showPrev'] = false;
    }
    else {
      newPagination["showPrev"] = true;
    }

    setPagination(newPagination);

  }, [paginationList])

  useEffect(() => {
    const fetchProfile = async () => {
      return await user.getProfile();
    };
    fetchProfile().then((userData) => {
      const proMembershipAccess = user.checkFeatureAccess(adminFeatureMapping.PRO_MEMBERSHIP_INVOICE);

      setHasCNGenerationAccess(user.checkFeatureAccess(adminFeatureMapping.GENERATE_CREDIT_NOTE));
  

      if (
        proMembershipAccess
      ) {
        setAdmin({
          adminId: userData.id,
        });
        const queryObj = getQueryParams(props.location.search);
        setContent((prev) => ({
          ...prev,
          pageNo: queryObj.pageNo,
        }));

        const filterObj = {
          ...queryObj
        };


        if(queryObj['startDate'] && moment(queryObj['startDate']).isValid()) {
          filterObj['startDate'] = moment(queryObj['startDate']).toDate();
        }

        if(queryObj['endDate'] && moment(queryObj['endDate']).isValid()) {
          filterObj['endDate'] = moment(queryObj['endDate']).toDate();
        }

        if(queryObj['invoiceType']) {
          filterObj['invoiceType'] = decodeURIComponent(queryObj['invoiceType']);
          queryObj['invoiceType'] = decodeURIComponent(queryObj['invoiceType']);
        }

        setFilters({...filterObj});

        const {documentNo, paymentGatewayId} = queryObj;

        setInputData({
          documentNo,
          paymentGatewayId
        })

        getInvoiceList(userData.id, queryObj, paginationList[0]['documentType'], paginationList[0]['offset']);
      } else {
        window.location.href = '/notAdmin';
      }
    });
  }, []);

  const getInvoiceList = async (adminId, filters = {}, documentType, offset) => {
    setFetchApiCall(true);

    try {
      const appliedFilters = {};
      for (const key in filters) {
        if (filters[key]) {
          appliedFilters[key] = filters[key];
          if (key == "startDate" || key == "endDate") {
            appliedFilters[key] = moment(filters[key]).format("YYYY-MM-DD");
          }
          if(key == 'invoiceType'){
            appliedFilters[key] = filters[key]
          }
          
        }
      }
      routeRequest({ pageSize: PAGE_CONTENT, ...appliedFilters });
      const res = await getProMemberShipInvoiceCreditNotesList(adminId, {
        offset,
        documentType,
        pageSize: PAGE_CONTENT,
        ...appliedFilters,
      });
      setContent({
        list: res.data.data.data,
      });
      const newPagination = {
        ...pagination
      };

      if(res.data.data.hasMore) {
        newPagination['showNext'] = true;
      }
      else {
        newPagination["showNext"] = false;
      }

      setPagination(newPagination);

      setPaginationList(prev => ([
        ...prev,
        {
          documentType: res.data.data.nextDocumentType,
          offset: res.data.data.nextOffset
        }
      ]))
     
      setFetchApiCall(false);
    } catch (err) {
      console.log(err);
      setFetchApiCall(false);
    }
  };

  const routeRequest = (filters) => {
    let array = [];

    for (const [key, value] of Object.entries(filters)) {
      if (value) {
        array.push(`${key}=${value}`);
      }
    }

    array = array.join("&");
    props.history.push("?" + array);
  };

  const loadNextPage = async (e) => {
    e.preventDefault();
    const filterObj = { ...filters };

    await getInvoiceList(admin.adminId, filterObj,  paginationList[paginationList.length - 1]['documentType'], paginationList[paginationList.length - 1]['offset']);
  };

  const loadPrevPage = async (e) => {
    e.preventDefault();
    const filterObj = { ...filters };

    const newPagination = [...paginationList];

    newPagination.splice(newPagination.length - 2, 2);

    setPaginationList(newPagination);

    await getInvoiceList(admin.adminId, filterObj, paginationList[paginationList.length - 3]['documentType'], paginationList[paginationList.length - 3]['offset']);
  };

  const resetDate = async () => {
    const newFilters = {
      ...filters,
      startDate: "",
      endDate: "",
    };
    setFilters(newFilters);

    const newPagination = [...paginationList];
    newPagination.splice(newPagination.length - (newPagination.length - 1), newPagination.length - 1)
    setPaginationList(newPagination);
    await getInvoiceList(admin.adminId, newFilters, paginationList[0]['documentType'], paginationList[0]['offset']);
  };

  const search = async (ev) => {
    const { value } = ev.target;
    const appliedFilters = { ...filters, [value]: inputData[value] };
    setFilters(appliedFilters);
    const newPagination = [...paginationList];
    newPagination.splice(newPagination.length - (newPagination.length - 1), newPagination.length - 1)
    setPaginationList(newPagination);
    await getInvoiceList(admin.adminId, appliedFilters, paginationList[0]['documentType'], paginationList[0]['offset']);
  };

  const clear = async (ev) => {
    const { value } = ev.target;
    const appliedFilters = { ...filters, [value]: "" };
    setInputData({ ...inputData, [value]: "" });
    setFilters(appliedFilters);

    const newPagination = [...paginationList];
    newPagination.splice(newPagination.length - (newPagination.length - 1), newPagination.length - 1)
    setPaginationList(newPagination);
    await getInvoiceList(admin.adminId, appliedFilters, paginationList[0]['documentType'], paginationList[0]['offset']);
  };

  const handleInputChange = (ev) => {
    const { name, value } = ev.target;
    setInputData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleOnKeyPress = (event) => {
    if (event && event.key == "Enter") {
      search({ target: { value: event.target.name } });
    }
  };

  const handleFilterChange = (ev) => {
    const { name, value } = ev.target;
    setFilters({ ...filters, [name]: value });
  };

  const resetFilters = async () => {
    const newFilters = {
      ...filters,
      invoiceType: "",
      paymentGateway: "",
      subscriptionType: "",
    };
    setFilters(newFilters);

    const newPagination = [...paginationList];
    newPagination.splice(newPagination.length - (newPagination.length - 1), newPagination.length - 1)
    setPaginationList(newPagination);
    await getInvoiceList(admin.adminId, newFilters, paginationList[0]['documentType'], paginationList[0]['offset']);
  };

  const onSearch = async () => {
    const newPagination = [...paginationList];
    newPagination.splice(newPagination.length - (newPagination.length - 1), newPagination.length - 1)
    setPaginationList(newPagination);
    await getInvoiceList(admin.adminId, filters, paginationList[0]['documentType'], paginationList[0]['offset']);
  };

  const handleInvoiceModalClose = () => {
    setViewInvoiceModal(false);
    setModalItem(null);
  };

  const handleCreditModalClose = () => {
    setCreditNoteModal(null);
  };

  const onViewInvoice = async (details) => {
    setModalItem({ ...details });

    setViewInvoiceModal(true);
  };

  const onInvoiceLoadSuccess = ({ numPages }) => {
    setInvoiceNumPages(numPages);
  };

  const downloadInvoice = () => {
    window.open(
      `${isTechDomain() ? process.env.REACT_APP_BASE_URL_TECH : process.env.REACT_APP_BASE_URL}/admin/${admin.adminId}/jobseeker-admin/subscription/invoice/view-invoice?seekerId=${modalItem.userId}&subscriptionType=${modalItem.subscriptionTypeId}&viewType=download&documentNo=${modalItem.documentNo}`,
      "_blank"
    );
  };

  const generateCreditNote = async () => {
    try {
      setGenCreditNote(true);
      await createCreditNote(admin.adminId, creditNoteModal.userId, {
        createdBy: admin.adminId,
        invoiceId: creditNoteModal.documentNo,
        seekerId: creditNoteModal.userId,
      });

      toast.success("Credit note generated successfully");
      setGenCreditNote(false);

      setCreditNoteModal(null);

      const filterObj = { ...filters };

      await getInvoiceList(admin.adminId, filterObj, paginationList[paginationList.length - 2]['documentType'], paginationList[paginationList.length - 2]['offset']);
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
      setGenCreditNote(false);

    }
  };

  const onClickDownload = async () => {
    const appliedFilters = {};
    for (const key in filters) {
      if (filters[key]) {
        appliedFilters[key] = filters[key];
        if (key == "startDate" || key == "endDate") {
          appliedFilters[key] = moment(filters[key]).format("YYYY-MM-DD");
        }
      }
    }

    try {
      setDownloadingExcel(true);

      const res = await getProMemberShipInvoiceCreditNotesList(
        admin.adminId,
        {
          pageNo: content.pageNo,
          pageSize: PAGE_CONTENT,
          ...appliedFilters,
          exportFile: true,
          download: true,
        },
        true
      );

      var blob = new Blob([res.data]);
      var url = URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `invoice.xlsx`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setDownloadingExcel(false);
      
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
      setDownloadingExcel(false);
    }
  };

  return (
    <div className="pro-membership-invoice-list-wrapper">
      <Heading text="Pro Membership Invoice" />

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />

      <div className="pro-membership-invoice-list-heading">
        {/* <Button
          skin="dark"
          className="btn_pro_membership_invoice"
          text="View Invoice List"
          clickButton={() => {
            props.history.push("/pro-membership-invoice");
          }}
        /> */}

        <Button
          skin="light"
          className="btn_pro_membership_dwnld"
          text="Download Excel"
          clickButton={onClickDownload}
          loading={downloadingExcel}
          disabled={downloadingExcel}
        />
      </div>

      <div className="filters-container">
        <ButtonContainer heading={"Filter By:"}>
          <li key="serviceName">
            <label>Service Name</label>{" "}
            <Dropdown
              name="subscriptionType"
              data={subscriptionTypeList}
              dropdownChange={handleFilterChange}
              defaultValue={filters.subscriptionType}
            />{" "}
          </li>

          <li key="invoiceType">
            <label>Invoice Type</label>{" "}
            <Dropdown
              name="invoiceType"
              data={invoiceTypeList}
              dropdownChange={handleFilterChange}
              defaultValue={filters.invoiceType}
            />{" "}
          </li>

          <li key="paymentGateway">
            <label>Payment Gateway</label>{" "}
            <Dropdown
              name="paymentGateway"
              data={paymentGatewayList}
              dropdownChange={handleFilterChange}
              defaultValue={filters.paymentGateway}
            />{" "}
          </li>
          <li key="searchDate">
            <label></label>
            <br />
            <Button skin="dark" text="Search" clickButton={onSearch} />
          </li>
          <li key="resetDate">
            <label></label>
            <br />
            <Button skin="light" text="Reset" clickButton={resetFilters} />
          </li>
        </ButtonContainer>
      </div>

      <div className="filters-container">
        <ButtonContainer heading={"Filter By:"}>
          <li key="jobDate">
            <label>Start & End Date</label>
            <FromToDatePicker
              name="date"
              startDate={filters.startDate}
              endDate={filters.endDate}
              handleChangeStart={(e) =>
                setFilters({ ...filters, startDate: e })
              }
              handleChangeEnd={(e) =>
                setFilters({
                  ...filters,
                  endDate: new Date(new Date(e).setHours(23, 59, 59)),
                })
              }
              disabled={!filters.startDate}
              maxDate={moment(filters.startDate)
                .add(1, "year")
                .toDate()}
            />
          </li>
          <li key="searchDate">
            <label></label>
            <br />
            <Button skin="dark" text="Search" clickButton={onSearch} />
          </li>
          <li key="resetDate">
            <label></label>
            <br />
            <Button skin="light" text="Reset" clickButton={resetDate} />
          </li>
        </ButtonContainer>
      </div>

      <div className="filters-container">
        <div className="single-search-filter-set">
          <InputBox
            placeholder="Payment Gateway Id"
            name="paymentGatewayId"
            value={inputData.paymentGatewayId}
            onChange={handleInputChange}
            onKeyPress={handleOnKeyPress}
          />
          <Button
            skin="dark"
            text="Search"
            value="paymentGatewayId"
            clickButton={search}
          />
          <Button
            skin="light"
            text="Clear"
            value="paymentGatewayId"
            clickButton={clear}
          />
        </div>
      </div>

      <div className="filters-container">
        <div className="single-search-filter-set">
          <InputBox
            placeholder="Enter Document Number"
            name="documentNo"
            value={inputData.documentNo}
            onChange={handleInputChange}
            onKeyPress={handleOnKeyPress}
          />
          <Button
            skin="dark"
            text="Search"
            value="documentNo"
            clickButton={search}
          />
          <Button
            skin="light"
            text="Clear"
            value="documentNo"
            clickButton={clear}
          />
        </div>
      </div>

      <div className="row text-center">

        {pagination.showPagination ? (
          <div className="pro-membership-invoice-list-pagination">
            {pagination.showPrev ? (
              <li>
                <a href="#" onClick={loadPrevPage}>
                  {"<<Prev"}
                </a>
              </li>
            ) : null}

            {pagination.showNext ? (
              <li>
                <a href="#" onClick={loadNextPage}>
                  {"Next>>"}
                </a>
              </li>
            ) : null}
          </div>
        ) : null}

        {fetchApiCall ? (
          <Loader />
        ) : content.list.length ? (
          <div className="content">
            <Table fixed selectable className="mailers-table">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={4}>Document Date</Table.HeaderCell>
                  <Table.HeaderCell width={5}>Invoice No.</Table.HeaderCell>
                  <Table.HeaderCell width={5}>Customer Name</Table.HeaderCell>
                  <Table.HeaderCell width={3}>Invoice Type</Table.HeaderCell>
                  <Table.HeaderCell width={6}>Service Name</Table.HeaderCell>
                  <Table.HeaderCell width={5}>Bill To State</Table.HeaderCell>
                  <Table.HeaderCell width={5}>
                    Transaction/Ref Code
                  </Table.HeaderCell>
                  <Table.HeaderCell width={4}>Payment Gateway</Table.HeaderCell>
                  <Table.HeaderCell width={5}>PayU Id</Table.HeaderCell>
                  <Table.HeaderCell width={4}>Paid Amount</Table.HeaderCell>
                  <Table.HeaderCell width={4}>
                    Applied Invoice Date for CN Case
                  </Table.HeaderCell>
                  <Table.HeaderCell width={3}>Status</Table.HeaderCell>
                  <Table.HeaderCell width={6}>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {content.list.map((item, i) => {
                  return (
                    <Table.Row key={item.documentNo}>
                      <Table.Cell>{item.documentDate}</Table.Cell>
                      <Table.Cell>{item.documentNo} </Table.Cell>
                      <Table.Cell>{item.customerName}</Table.Cell>
                      <Table.Cell>{item.invoiceType}</Table.Cell>
                      <Table.Cell>{item.subscriptionType}</Table.Cell>
                      <Table.Cell>{item.billToState}</Table.Cell>
                      <Table.Cell>{item.refCode}</Table.Cell>
                      <Table.Cell>{item.paymentGateway}</Table.Cell>
                      <Table.Cell>{item.paymentGatewayId}</Table.Cell>
                      <Table.Cell>{item.netInvoiceAmount}</Table.Cell>
                      <Table.Cell>{item.appliedInvoiceDate}</Table.Cell>
                      <Table.Cell>
                        {item.invoiceType == "Invoice"
                          ? "Purchased"
                          : "Refunded"}
                      </Table.Cell>
                      <Table.Cell>
                        <Button
                          text={`View ${item.invoiceType == 'Invoice' ? 'invoice' : 'credit note'}`}
                          skin="dark"
                          clickButton={() => onViewInvoice(item)}
                        />
                       {
                          item.invoiceType == 'Invoice' && hasCNGenerationAccess ? (
                            <Button
                              text="Generate Credit Note"
                              skin={item.creditNoteNo ? 'light' : "dark"}
                              clickButton={() => setCreditNoteModal(item)}
                              disabled={!!item.creditNoteNo}
                            />

                          ): null
                        }
                        
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
        ) : (
          <div>No Records Found</div>
        )}
         {pagination.showPagination ? (
          <div className="pro-membership-invoice-list-pagination">
            {pagination.showPrev ? (
              <li>
                <a href="#" onClick={loadPrevPage}>
                  {"<<Prev"}
                </a>
              </li>
            ) : null}

            {pagination.showNext ? (
              <li>
                <a href="#" onClick={loadNextPage}>
                  {"Next>>"}
                </a>
              </li>
            ) : null}
          </div>
        ) : null}
      </div>

      <Modal
        className="applications-resume-modal"
        open={viewInvoiceModal}
        onClose={handleInvoiceModalClose}
        size="large"
      >
        {modalItem && (
          <>
            <Header content={modalItem.documentNo} />
            <Modal.Content scrolling>
              {modalItem ? (
                <div className="resume-container">
                  <Document
                    file={{
                      url: `${ isTechDomain() ? process.env.REACT_APP_BASE_URL_TECH :  process.env.REACT_APP_BASE_URL}/admin/${admin.adminId}/jobseeker-admin/subscription/invoice/view-invoice?seekerId=${modalItem.userId}&subscriptionType=${modalItem.subscriptionTypeId}&viewType=download&documentNo=${modalItem.documentNo}`,
                      withCredentials: true,
                    }}
                    onLoadSuccess={onInvoiceLoadSuccess}
                    onSourceError={() => {}}
                    error="No Invoice Found!"
                  >
                    {Array.from(Array(invoiceNumPages).keys()).map((key) => (
                      <Page key={key} scale={0.7} pageNumber={key + 1} />
                    ))}
                  </Document>
                </div>
              ) : (
                <div>No Invoice Found!</div>
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button
                clickButton={downloadInvoice}
                skin="dark"
                text={`Download ${modalItem.invoiceType == "Invoice" ? "invoice" : "credit note"}`}
              />
              <Button
                clickButton={handleInvoiceModalClose}
                skin="light"
                text="Close"
              />
            </Modal.Actions>
          </>
        )}
      </Modal>

      <Modal
        className="applications-resume-modal"
        open={creditNoteModal}
        onClose={handleCreditModalClose}
        size="small"
      >
        {creditNoteModal && (
          <>
            <Header content="Please confirm" />
            <Modal.Content>
              <div>
                Are you sure you want to generate a credit note? Please generate
                this if the transaction is refunded 
              </div>
            </Modal.Content>
            <Modal.Actions>
              <Button
                clickButton={generateCreditNote}
                skin="dark"
                text="Yes, Generate credit note"
                loading={genCreditNote}
                disabled={genCreditNote}
              />
              <Button
                clickButton={handleCreditModalClose}
                skin="light"
                text="Close"
              />
            </Modal.Actions>
          </>
        )}
      </Modal>
    </div>
  );
};

export default ProMembershipInvoiceCN;
